import { api, LightningElement } from "lwc";

import { Logo } from "../header/types";

export default class extends LightningElement {
  @api logo: Logo = null!;
  @api layout: "desktop" | "mobile" = "desktop";

  private logoSize:
    | {
        height: number;
        width: number;
      }
    | undefined = undefined;

  private get imgStyle() {
    // Required so Firefox doesn't collapse an SVG missing width/height to 0x0
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1328124#c3
    if (this.logoSize && this.logoSize.height === 0) return "height: 200px;";
    return "";
  }

  private get style() {
    if (!this.logoSize) return "";
    let { height, width } = this.logoSize;
    if (width === 0 || height === 0) return "";
    return `width: ${width}px; height: ${height}px`;
  }

  private get altText() {
    return this.logo?.assistiveText || "";
  }

  private onLoad(e: Event) {
    let img = e.currentTarget as HTMLImageElement;
    this.logoSize = {
      height: img.height,
      width: img.width,
    };
  }
}
